import React, { Component, Fragment } from "react";

import { FiArrowUp } from "react-icons/fi";
import { Fonts } from "Themes";
import { IoIosCloseCircle } from "react-icons/io";
import LoadingIcon from "Components/LoadingIcon";
import moment from "moment";
import styled from "styled-components";
import styles from "./styles.module.scss";


const ProjectUpdateTime = styled.div`
  font-size: ${Fonts.fontSize.tiny}px;
`;

const PathLine = styled.div`
  border: solid 2px lightgray;
  height: 50px;
`;

const CloseIcon = styled(IoIosCloseCircle)`
  position: absolute;
  right: -5px;
  top: -25px;
  opacity: 1;
`;

const RatingContainer = styled.div`
  border-radius: 100px;
  border: solid 2px lightgray;
  width: 40px;
  height 40px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

class ProjectUpdate extends Component {
  state = {};
  render() {
    const { updates, editable, removeUpdate, onClick } = this.props;

    if (!updates) return <LoadingIcon />;

    return (
      <div className={styles.container}>
        {updates.map(({ update, created, id, rating }, key) => (
          <Fragment key={key}>
            {key !== 0 && <PathLine />}
            <div className={styles.update}
              onClick={!editable ? () => onClick(id) : () => {}}
            >
              {editable && (
                <div style={{ position: "relative" }}>
                  <CloseIcon size={30} onClick={() => removeUpdate(id)} />
                </div>
              )}
              <RatingContainer>
                <FiArrowUp fontSize={15} /> {rating}
              </RatingContainer>
              <div className={styles.updateText}>
                {update}
                <ProjectUpdateTime>
                  {moment(created).isValid && moment(created).fromNow()}
                </ProjectUpdateTime>
              </div>
            </div>
          </Fragment>
        ))}
      </div>
    );
  }
}

export default ProjectUpdate;
